import { Component } from '@angular/core';

@Component({
    templateUrl: './account-layout.component.html',
    styleUrls: ['./account-layout.component.scss'],
    standalone: false
})
export class AccountLayoutComponent { }
